// @ts-nocheck
import { useState, useEffect, useReducer } from 'react';
import { PhotogrammetryModelOption } from './PhotogrammetryModelOption';
import { ModelOption } from './ModelOption';
import { ModelSetOption } from './ModelSetOption';
import { PointCloudOption } from './PointCloudOption';
import { PipelineOption } from './PipelineOption';
import { ProjectorOption } from './ProjectorOption';
import { OGCI3SOption } from './OGCI3SOption';
import { OGC3DTilesOption } from './OGC3DTilesOption';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const Layer3DOption = (props) => {
    const [layerList, setLayerList] = useState([]);
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    useEffect(() => {
        setLayerList(props.selectedlayer);
    }, [props.selectedlayer])

    const layerUpdate = (layer, index) => {
        let layers = layerList;
        layers[index] = layer;
        setLayerList(layers);
        forceUpdate();
    }

    const layerRemove = (index) => {
        let layers = layerList;
        let layer = layerList[index];
        window.main.OView.removeLayer(layer.layerObject);
        props.toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已關閉圖層：' + layer.TITLE });
        layers.splice(index, 1);
        setLayerList(layers);
        props.LayerOptionRemove(layers);
        forceUpdate();
    }

    const optionFuncMap = (item, index) => {
        switch (item.TYPE) {
            case 'PhotogrammetryModel':
                return <PhotogrammetryModelOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} selected2Dlayer={props.selected2Dlayer} />
            case 'Model':
                return <ModelOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} selected2Dlayer={props.selected2Dlayer} />
            case 'ModelSet':
                return <ModelSetOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} selected2Dlayer={props.selected2Dlayer} />
            case 'PointCloud':
                return <PointCloudOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} />
            case 'Pipeline':
                return <PipelineOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} />
            case 'Projector':
                return <ProjectorOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} />
            case 'OGCI3S':
                return <OGCI3SOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} />
            case 'OGC3DTiles':
                return <OGC3DTilesOption id={item.ID} layer={item} index={index} layerRemove={layerRemove} layerUpdate={layerUpdate} />
            default:
                break;

        }
    }

    return (
        <div className="card">
            {
                layerList.map((item, index) =>
                    optionFuncMap(item, index)
                )
            }
        </div>
    )
}